import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Typography from "@material-ui/core/Typography";
import useStyles from "./styles/mobileMenu";
import link from "../../static/text/link";
import { withTranslation } from "../../i18n";

const linkContent = {
    articles: {
        fatloss: link.mobile.articleCategory("fatloss"),
        workout: link.mobile.articleCategory("workouts"),
        nutrition: link.mobile.articleCategory("nutrition"),
        healthyLiving: link.mobile.articleCategory("healthy-living"),
        personalDevelopment: link.mobile.articleCategory("personal-development"),
    },
    about: {
        aboutUs: link.mobile.static("about"),
        privacyPolicy: link.mobile.static("privacy-policy"),
        termsOfUse: link.mobile.static("terms-of-use"),
        // Trello 585 (13 OCT 2026): same legal trio components/Header/MobileMenu
        // and the footer already link, directly below Terms of Use.
        refundPolicy: link.mobile.static("refund-policy"),
        washingtonHealthDataPolicy: link.mobile.static("consumer-health-data-privacy"),
        nevadaHealthDataPolicy: link.mobile.static("nevada-health-data-policy"),
        contactUs: link.mobile.static("contact-us"),
    }
}

function MobileMenu(props) {
    const classes = useStyles();
    const { toggleDrawer, open, t } = props;

    function renderActive(path) {
        const currentPath = window.location.pathname;
        if (path === currentPath) {
            return classes.menuText;
        }
        return null;
    }

    const SideList = () => (
        <div
            className={classes.mobileNav}
            role="presentation"
            onClick={toggleDrawer}
            onKeyDown={toggleDrawer}
        >
            <div className={clsx(classes.menu, open && classes.menuOpen)}>
                <div className={clsx(classes.menuSection, classes.topMenuSection)}>
                    <div className={classes.menuInner}>
                        <a href={"/"}>
                            <Typography className={clsx(classes.menuItemText, renderActive("/"))}>{t("home")}</Typography>
                        </a>
                        <a href={linkContent.articles.fatloss}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.articles.fatloss))}>{t("fatlossDefault")}</Typography>
                        </a>
                        <a href={linkContent.articles.workout}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.articles.workout))}>{t("workoutDefault")}</Typography>
                        </a>
                        <a href={linkContent.articles.nutrition}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.articles.nutrition))}>{t("nutritionDefault")}</Typography>
                        </a>
                        <a href={linkContent.articles.healthyLiving}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.articles.healthyLiving))}>{t("healthy_livingDefault")}</Typography>
                        </a>
                        <a href={linkContent.articles.personalDevelopment}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.articles.personalDevelopment))}>{t("personal_developmentDefault")}</Typography>
                        </a>
                    </div>
                </div>
                <div className={classes.separator} />
                <div className={classes.menuSection}>
                    <div className={clsx(classes.menuInner, classes.menuHasMargin)}>
                        <a href={linkContent.about.aboutUs}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.about.aboutUs))}>{t("about_us")}</Typography>
                        </a>
                        <a href={linkContent.about.privacyPolicy}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.about.privacyPolicy))}>{t("privacy_policy")}</Typography>
                        </a>
                        <a href={linkContent.about.termsOfUse}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.about.termsOfUse))}>{t("terms_of_use")}</Typography>
                        </a>
                        <a href={linkContent.about.refundPolicy}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.about.refundPolicy))}>{t("refund_policy")}</Typography>
                        </a>
                        <a href={linkContent.about.washingtonHealthDataPolicy}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.about.washingtonHealthDataPolicy))}>{t("washington_health_data_policy")}</Typography>
                        </a>
                        <a href={linkContent.about.nevadaHealthDataPolicy}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.about.nevadaHealthDataPolicy))}>{t("nevada_health_data_policy")}</Typography>
                        </a>
                        <a href={linkContent.about.contactUs}>
                            <Typography className={clsx(classes.menuItemText, renderActive(linkContent.about.contactUs))}>{t("contact_us")}</Typography>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <SwipeableDrawer
            open={open}
            onClose={toggleDrawer}
            onOpen={toggleDrawer}
            classes={{
                paper: classes.paperNav
            }}
        >
            <SideList />
        </SwipeableDrawer>
    );
}


export default withTranslation(["myfitsociety"])(MobileMenu);
